import { slideDown, slideUp } from "es6-slide-up-down";

const TocToggle = () => {
	const tocs = document.querySelectorAll(".theeblock--table-of-contents");
	if (tocs) {
		tocs.forEach((toc) => {
			const trigger = toc.querySelector(".toc-toggle");
			const list = toc.querySelector(".toc");

			trigger.addEventListener("click", (e) => {
				if (list.classList.contains("hidden")) {
					slideDown(list);
                    trigger.innerHTML = 'Hide <i class="text-orange fa-solid fa-circle-chevron-up"></i>';
					list.classList.remove("hidden");
				} else {
                    slideUp(list);
                    trigger.innerHTML = 'Show <i class="text-orange fa-solid fa-circle-chevron-down"></i>';
					list.classList.add("hidden");
				}
				e.preventDefault();
			});
		});
	}
};

TocToggle();

export default TocToggle;
